module.exports = __webpack_public_path__ + "img/map.2e0af41c.jpg";